import { Medal } from "@/components/athlete-overview-page/athlete-podium/medal";
import { Paragraph } from "@digdir/designsystemet-react";
import clsx from "clsx";
import { AthleteOverviewAthlete } from "@/components/athlete-overview-page/athlete-overview-athlete";
import { UseAthleteOverview } from "../athlete-overview-page-provider";

export function PodiumCard(athlete: AthleteOverviewAthlete) {
    const { updateSearchParams } = UseAthleteOverview()
    return (
        <div onClick={() => updateSearchParams({ fisCode: athlete.fisCode })}
            className="relative flex flex-col w-full h-full cursor-pointer justify-center md:justify-end">
            <div className="absolute md:relative flex items-end justify-end w-full ">
                <div className="hidden xl:flex relative z-20 w-full aspect-square p-5">
                    <div className="rounded-full overflow-hidden w-full h-full">
                        <img
                            src={athlete.imageUrl}
                            alt={athlete.fullName}
                            className="w-full h-full object-cover"
                        />
                    </div>
                </div>
                <Medal rank={athlete.ranking} />
                <div className={clsx("hidden md:block xl:absolute bottom-0 left-0 w-full bg-main-base",
                    {
                        "h-10 xl:h-30": athlete.ranking === 1,
                        "h-5 xl:h-20": athlete.ranking === 2,
                        "h-2.5 xl:h-10": athlete.ranking === 3
                    }
                )} />
            </div>
            <div className="flex flex-col p-5 md:h-[220px] bg-main-base text-white">
                <Paragraph data-size="md" className="!mb-0">{athlete.firstName}</Paragraph>
                <Paragraph data-size="xl" className="!mb-0">{athlete.lastName}</Paragraph>
                <div className="w-full flex flex-col xs:flex-row xs:gap-10 md:justify-between">
                    <Paragraph data-size="xs" className="font-bold !mb-0">{athlete.club}</Paragraph>
                    <Paragraph data-size="xs" className="font-bold !mb-0">{athlete.points} Poeng</Paragraph>
                </div>
            </div>
        </div>
    )
}